import { useContext } from 'react'
import { DataContext } from '../context/DataContext'
import cmsInstance from '../helpers/cmsInstance'
import { checkLocations, matchProductsLocations } from '../helpers/filterPoints'

export const useCmsAdapter = () => {
  const { /* userInfo, currentStep,  */ecommerceInfo, setLocalPoints, companyInfo, cartData } =
    useContext(DataContext)
  const { pinflagApiKey/* , companyName */ } = companyInfo

  const postTrackingEvent = (eventType, body) => {
    /* cmsInstance
      .post('/tracking/event', {
        storeName: companyName,
        userEmail: userInfo.email,
        currentUrl: ecommerceInfo.currentUrl,
        currentCheckoutStep: `${currentStep}`,
        currentCheckoutSubstep: '',
        previousCheckoutStep: '',
        previousCheckoutSubstep: '',
        eventType,
        ...body
      })
      .catch(err => console.error(err)) */
  }

  const getVariantLocations = (variantId) => {
    return cmsInstance.post('/shopify/locations', {
      pinflagApiKey,
      variantId: `gid://shopify/ProductVariant/${variantId}`
    })
  }

  const filterPickupPoints = async () => {
    if (cartData.lines.length > 3) {
      setLocalPoints({ disabled: true, points: [] })
      return
    }
    const enabledPoints = []
    try {
      for (let index = 0; index < cartData.lines.length; index++) {
        const product = cartData.lines[index]
        const response = await getVariantLocations(product.variantId)
        const { edges } =
          response.data.data.productVariant.inventoryItem.inventoryLevels
        const points = checkLocations(edges, product.quantity)
        enabledPoints.push(points)
      }
      const localPoints = matchProductsLocations(enabledPoints)

      if (!localPoints.length) { return setLocalPoints({ disabled: true, points: [] }) }
      setLocalPoints({
        disabled: false,
        points: localPoints
      })
    } catch (err) {
      console.error(err)
    }
  }

  const getCheckout = checkoutId => {
    return cmsInstance.get(
      `/shopify/checkout?pinflagApiKey=${pinflagApiKey}&checkoutId=${checkoutId}`
    )
  }

  const createCheckout = input => {
    return cmsInstance.post('/shopify/checkout', {
      input,
      pinflagApiKey
    })
  }

  const updateEmailCheckout = (checkoutId, email) => {
    return cmsInstance.post('/shopify/checkout/update-email', {
      checkoutId,
      email,
      pinflagApiKey
    })
  }

  const setItemsCheckout = (checkoutId, oldLineItemsId, newLineItems) => {
    return cmsInstance.post('/shopify/checkout/set-items', {
      checkoutId,
      oldLineItemsId,
      newLineItems,
      pinflagApiKey
    })
  }

  const updateAddressCheckout = (checkoutId, address) => {
    return cmsInstance.post('/shopify/checkout/update-address', {
      checkoutId,
      address,
      pinflagApiKey
    })
  }

  const getShippingRates = checkoutId => {
    return cmsInstance.get(
      `/shopify/checkout/get-shipping-rates?pinflagApiKey=${pinflagApiKey}&checkoutId=${checkoutId}`
    )
  }

  const setShippingRate = (checkoutId, shippingRateHandle) => {
    return cmsInstance.post('/shopify/checkout/set-shipping-rate', {
      checkoutId,
      shippingRateHandle,
      pinflagApiKey
    })
  }

  const removeItemsCheckout = (checkoutId, lineItemsId) => {
    return cmsInstance.post('/shopify/checkout/remove-items', {
      checkoutId,
      lineItemsId,
      pinflagApiKey
    })
  }

  const sendCartNotesShopify = (checkoutId, notes, isGiftWrapping, giftNote) => {
    const { cms } = ecommerceInfo
    if (cms !== 'shopify') return
    return cmsInstance.post('/shopify/checkout/update-attributes', {
      checkoutId,
      pinflagApiKey,
      input: isGiftWrapping
        ? {
            note: notes,
            customAttributes: giftNote
              ? [
                  {
                    key: 'gift-wrapping',
                    value: 'on'
                  },
                  {
                    key: 'Gift Note',
                    value: giftNote
                  }
                ]
              : [
                  {
                    key: 'gift-wrapping',
                    value: isGiftWrapping ? 'on' : 'off'
                  }
                ]
          }
        : { note: notes }
    })
  }

  const updateCustomAttributesShopify = (checkoutId, input) => {
    const { cms } = ecommerceInfo
    if (cms !== 'shopify') return
    return cmsInstance.post('/shopify/checkout/update-attributes', {
      checkoutId,
      pinflagApiKey,
      input
    })
  }

  const ignoreProfileDataVtex = orderFormId => {
    return cmsInstance.post('/vtex/order/ignore-personal-data', {
      orderFormId,
      pinflagApiKey
    })
  }

  const getOrderFormVtex = (orderFormId, pinflagApiKey) => {
    return cmsInstance.get(`/vtex/order-form?pinflagApiKey=${pinflagApiKey}&orderFormId=${orderFormId}`)
  }

  const setClientDataVtex = (orderFormId, clientData) => {
    console.log('😺 ~ setClientDataVtex ~ orderFormId, clientData:', orderFormId, clientData)
    return cmsInstance.post('/vtex/order-form/client-data', {
      orderFormId,
      pinflagApiKey,
      clientData
    })
  }

  const setShippingDataVtex = (orderFormId, shippingData, logisticsInfo) => {
    console.log('😺 ~ setShippingDataVtex ~ orderFormId, shippingData, logisticsInfo:', orderFormId, shippingData, logisticsInfo)
    return cmsInstance.post('/vtex/order-form/shipping-data', {
      orderFormId,
      pinflagApiKey,
      shippingData,
      logisticsInfo
    })
  }

  const getWeightVtex = (items, pinflagApiKey) => {
    return cmsInstance.post('/vtex/items-weights', {
      pinflagApiKey,
      items
    })
  }

  return {
    postTrackingEvent,
    filterPickupPoints,
    getCheckout,
    createCheckout,
    updateEmailCheckout,
    setItemsCheckout,
    updateAddressCheckout,
    getShippingRates,
    setShippingRate,
    removeItemsCheckout,
    ignoreProfileDataVtex,
    sendCartNotesShopify,
    updateCustomAttributesShopify,
    getOrderFormVtex,
    setClientDataVtex,
    setShippingDataVtex,
    getVariantLocations,
    getWeightVtex
  }
}
